/**
 * Behaviour Management Feature Flag
 * Single source of truth for enabling/disabling the entire Behaviour
 * Management module (sidebar entry, Modules card, settings routes, store
 * access). Edit this file to flip the master switch or pilot the feature
 * with specific schools.
 */

/** Master switch — set to `false` to hide the feature for everyone. */
const BEHAVIOUR_MANAGEMENT_ENABLED = false

/**
 * School IDs explicitly allowed (whitelisted) even when the master switch is
 * off. Use this to pilot the feature with specific schools without enabling
 * it globally.
 * @type {readonly number[]}
 */
const SCHOOL_ALLOWED_OVERRIDES = Object.freeze([
  5700, 8540, 1373, 6563, 1406, 2293, 2310, 3518, 3587, 6564, 1404, 1407, 2456,
  4199, 5011
])

/**
 * School IDs explicitly denied (blacklisted) even when the master switch is
 * on. Use this to opt out specific schools from a globally enabled feature.
 * @type {readonly number[]}
 */
const SCHOOL_DENIED_OVERRIDES = Object.freeze([])

/**
 * Returns true when Behaviour Management is enabled for the given school.
 * @param {number|string|null|undefined} schoolId - Active school id
 * @returns {boolean}
 */
const isBehaviourManagementEnabled = (schoolId) => {
  const id = schoolId == null ? null : Number(schoolId)

  if (id != null && SCHOOL_DENIED_OVERRIDES.includes(id)) {
    return false
  }

  if (BEHAVIOUR_MANAGEMENT_ENABLED) {
    return true
  }

  return id != null && SCHOOL_ALLOWED_OVERRIDES.includes(id)
}

export default {
  BEHAVIOUR_MANAGEMENT_ENABLED,
  SCHOOL_ALLOWED_OVERRIDES,
  SCHOOL_DENIED_OVERRIDES,
  isBehaviourManagementEnabled
}
